import { TypedDocumentNode, gql } from '@apollo/client';

import LoadingIndicator from '@sorare/core/src/atoms/loader/LoadingIndicator';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';
import { useTypedParams } from '@sorare/core/src/lib/routing';
import { isRarityStr } from '@sorare/core/src/lib/so5';

import { PlayerWithSupply } from '@sorare/gameplay/src/components/rewards/PlayerWithSupply';

import {
  FootballRewardsFixtureLeagueQualityRarityPageQuery,
  FootballRewardsFixtureLeagueQualityRarityPageQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

export const REWARDS_FIXTURE_LEAGUE_QUALITY_RARITY_PAGE_QUERY = gql`
  query FootballRewardsFixtureLeagueQualityRarityPageQuery(
    $league: String!
    $rarity: String!
    $quality: String!
  ) {
    so5 {
      so5League(slug: $league) {
        slug
        rewardPool(rarity: $rarity, quality: $quality) {
          slug
          ...PlayerWithSupply_playerWithSupply
        }
        ...PlayerWithSupply_so5League
      }
    }
  }
  ${PlayerWithSupply.fragments.playerWithSupply}
  ${PlayerWithSupply.fragments.so5League}
` as TypedDocumentNode<
  FootballRewardsFixtureLeagueQualityRarityPageQuery,
  FootballRewardsFixtureLeagueQualityRarityPageQueryVariables
>;

const RewardsPage = () => {
  const { league, quality, rarity } = useTypedParams<PageParams>();

  const { data, loading } = useQuery(
    REWARDS_FIXTURE_LEAGUE_QUALITY_RARITY_PAGE_QUERY,
    {
      variables: { league, quality: quality.toLowerCase(), rarity },
    }
  );
  const { so5League } = data?.so5 || {};

  if (loading) {
    return <LoadingIndicator />;
  }

  if (!so5League || !isRarityStr(rarity)) {
    return null;
  }

  return (
    <PlayerWithSupply
      so5League={so5League}
      players={so5League.rewardPool}
      rarity={rarity}
    />
  );
};
export default RewardsPage;
